import  { useEffect } from "react";
import { connect } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { getAccessToken, getAgentsPresence } from "../Services/GraphServices";
import { setAgentPresences } from "../Redux/Actions/agentsActions";

const PresenceContainer = ({ supervisedAgentIds, setAgentPresences }) => {
  const authContext = useMsal();
  const { accounts, instance } = authContext;
  const activeAccount = accounts[0];

  // Fonction pour récupérer et mettre à jour les présences
  const fetchAllPresences = () => {
    getAccessToken(instance, activeAccount)
      .then((token) => {
        getAgentsPresence(supervisedAgentIds, token)
          .then((presenceData) => {
            if (presenceData?.value?.length > 0) {
              const newPresences = presenceData.value.reduce((acc, presence) => {
                acc[presence.id] = {
                  availability: presence.availability,
                  activity: presence.activity,
                };
                return acc;
              }, {});
              setAgentPresences(newPresences);
            }
          })
          .catch((error) => {
            console.error("Erreur lors de la récupération des présences:", error);
          });
      })
      .catch((error) => {
        console.error("Erreur lors de l'obtention du jeton d'accès:", error);
      });
  };

  useEffect(() => {
    if (supervisedAgentIds?.length > 0) {
      fetchAllPresences();

      const interval = setInterval(() => {
        fetchAllPresences();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [supervisedAgentIds]);

 
};

const mapStateToProps = (state) => ({
  supervisedAgentIds: state.reducer.supervisedAgentIds, 
});

const mapDispatchToProps = (dispatch) => ({
  setAgentPresences: (presences) => dispatch(setAgentPresences(presences)), 
});

export default connect(mapStateToProps, mapDispatchToProps)(PresenceContainer);
